import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { StudentWarningsRiskLevel } from '../types';

type RiskLevelBadgeProps = {
  riskLevel: StudentWarningsRiskLevel;
};

const BG = {
  [StudentWarningsRiskLevel.Low]: '#CEF0DA',
  [StudentWarningsRiskLevel.Medium]: '#FFE6A1',
  [StudentWarningsRiskLevel.High]: '#F2C0BD',
};

const RiskLevelBadge = ({ riskLevel }: RiskLevelBadgeProps) => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_SUMMARY);

  return (
    <div className="d-flex w-100 align-items-center justify-content-center">
      <div
        className="d-flex align-items-center justify-content-start"
        style={{ gap: 8, width: 120 }}
      >
        <div
          className="border border-primary"
          style={{ width: 20, height: 20, backgroundColor: BG[riskLevel] }}
        />
        <span>{t(`riskLevels.${riskLevel}`)}</span>
      </div>
    </div>
  );
};

export default RiskLevelBadge;
